import { http } from "./httpServices";
import { MEMBERSHIP } from "./constants";

export function getMembershipData(page: number, limit: number) {
  return http.get(`${MEMBERSHIP}`, {
    params: {
      page: page,
      limit: limit,
      status: "processing",
    },
  });
}

export function getMembershipHistoryData(amdHistoryPage: number,search: string,status: string) {
  return http.get(`${MEMBERSHIP}`, {
    params: {
      status,
      search,
      page: amdHistoryPage,
      limit: 5,
    },
  });
}

export function putMembershipApprovalData(
  data: {
    approved: number;
    rejectNotes: string;
  },
  id: string
) {
  return http.put(`${MEMBERSHIP}/approval/${id}`, data);
}

export function getDownloadMembershipReport(status: string, search: string,limit: number) {
  return http.get(`${MEMBERSHIP}/download-membership-report`, {
    responseType: "blob",
    params: {
      status,
      search,
      limit
    },
  });
}

export function getMembershipDetails(id: any) {
  return http.get(`${MEMBERSHIP}/details/${id}`);
}
